const DEFAULT_API_BASE_URL = "https://4pa4z5pzv1.execute-api.eu-south-1.amazonaws.com/prod";

export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL).replace(/\/$/, "");

async function apiRequest(path, options = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, options);
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message = payload?.error || `Request failed (${response.status})`;
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  return payload;
}

export async function apiGet(path, options = {}) {
  return apiRequest(path, {
    headers: {
      ...(options.headers || {})
    }
  });
}

export async function apiPost(path, body, options = {}) {
  return apiRequest(path, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {})
    },
    body: JSON.stringify(body)
  });
}

export async function apiPatch(path, body, options = {}) {
  return apiRequest(path, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {})
    },
    body: JSON.stringify(body)
  });
}

export async function apiPut(path, body, options = {}) {
  return apiRequest(path, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {})
    },
    body: JSON.stringify(body)
  });
}

export async function apiDelete(path, options = {}) {
  return apiRequest(path, {
    method: "DELETE",
    headers: {
      ...(options.headers || {})
    }
  });
}

export function formatEuro(cents) {
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR"
  }).format((Number(cents) || 0) / 100);
}
